import { render, staticRenderFns } from "./openCorporateDataComponent.vue?vue&type=template&id=4860067a"
import script from "./openCorporateDataComponent.vue?vue&type=script&lang=js"
export * from "./openCorporateDataComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports